<template>
    <div class="row">
        <template v-if="recinto">
            <div class="col-12 col-lg-8" v-if="zona.with_seats">
                <AsientosComponent
                    :zona="zona_seleccionada"
                    :asientos="datos_de_compradores"
                    :asientoParaBorrar="asientoParaBorrar"
                    :puede_cambiar="puede_cambiar"
                    :dia_abonado="dia_abonado"
                    :forzar_adyacentes="false"
                    :bloquearPasoDos="bloquearPasoDos"
                    :asientos_maximos="asientos_maximos"
                    :allow_blocked_seats="allow_blocked_seats"
                    v-on:actualizarDatos="actualizarDatos"
                />
            </div>
            <div class="col-12 col-lg-8" v-else>
                <div class="col-12">
                    <p>Seleccione el numero de entradas</p>
                    <div class="form-group">
                        <multiselect
                            v-model="n_entradas"
                            placeholder="Seleccione el nº de entradas"
                            :show-labels="false"
                            :options="options"
                            :allow-empty="false"
                            @select="actualizarDatos"
                        />
                    </div>
                </div>
            </div>
            <div class="col-12 col-lg-4">
                <div class="col-12">
                    <SelectorZonaComponent
                        v-if="place.tipo_svg === 1"
                        :dia_abonado="dia_abonado"
                        :zona="zona_seleccionada"
                        :zonas="zonas_formateadas"
                        :place="place"
                        :sesion_id="$route.params.sesion_id"
                        :bloquearPasoDos="bloquearPasoDos"
                        @cambiarZona="cambiarZona"
                    />
                </div>
                <div class="col-12">
                    <TusAsientosComponent
                        :asientos="datos_de_compradores"
                        :bloquearPasoDos="bloquearPasoDos"
                        :zona="zona_seleccionada"
                        :n_butacas="asientos_maximos"
                        :disableInput="disableInput"
                        v-on:continuar="bloquearAsientos"
                        @eliminar-asiento="asientoParaBorrar = $event"
                        :configuracion_valida="true"
                        @update="updateAsientos()"
                    />
                </div>
            </div>
        </template>
        <template v-if="!recinto">
            <div class="col-12 col-lg-7">
                <EntradasSinRecintoComponent
                    :entradas="entradas"
                    :sesion="sesion"
                    v-on:actualizar="actualizar"
                    :disableInput="disableInput"
                />
            </div>
            <div class="col-12 col-lg-1"></div>
            <div class="col-12 col-lg-4">
                <DatosEntradasSinZonaComponent
                    v-if="!loading"
                    :entradas="entradas"
                    :disableInput="disableInput"
                    v-on:continuar="bloquearAsientos"
                    :siguiente="siguiente"
                />
            </div>
        </template>
    </div>
</template>

<script>
    import AsientosComponent from '@/components/backend/stepper/components/AsientosComponent';
    import SelectorZonaComponent from '@/components/backend/stepper/components/SelectorZonaComponent';
    import TusAsientosComponent from '@/components/backend/stepper/components/TusAsientosComponent';
    import EntradasSinRecintoComponent from '@/components/backend/stepper/components/EntradasSinRecintoComponent';
    import DatosEntradasSinZonaComponent from '@/components/backend/stepper/components/DatosEntradaSinZonaComponent';

    export default {
        props: [
            'evento', 'sesion', 'zona', 'datos_compradores', 'recinto', 'entradas', 'puede_cambiar','zonas_formateadas',
            'dia_abonado', 'place', 'mode', 'continuarConAsiento', 'bloquearPasoDos', 'disableInput',
            // Reenvía a AsientosComponent la capacidad de seleccionar butacas
            // bloqueadas (venta en taquilla). Por defecto `undefined` => false,
            // así que los flujos que no lo pasan mantienen la política del
            // componente compartido.
            'allow_blocked_seats'
        ],
        data() {
            return {
                search: '',
                search_for: 'n_abonado',
                loading: false,
                zona_seleccionada: this.zona,
                siguiente: false,
                carrito_id: null,
                abonado: {},
                datos_de_compradores: this.datos_compradores,
                asientoParaBorrar: null,
                asientos_maximos: 1,
                n_entradas: 0
            }
        },
        created() {
            if(this.dia_abonado) {
                if (this.evento.tiene_recinto) {
                    if (this.zona.aforo && !this.continuarConAsiento) {
                        delete this.datos_de_compradores[0].asiento
                        this.asientos_maximos = this.zona.aforo
                    }
                }
                this.asientos_maximos = 1 + this.evento.n_acompanantes;

                this.abonado.nombre = this.datos_de_compradores[0].nombre;
                this.abonado.apellidos = this.datos_de_compradores[0].apellidos;
                this.abonado.id = this.datos_de_compradores[0].id;
            }

            if (this.mode === 3 && (this.evento.n_acompanantes && this.evento.n_acompanantes > 0)) { //Venta amigo del abonado
                this.asientos_maximos = this.evento.n_acompanantes;
            }

            if (this.mode === 1) { //Venta normal
                this.asientos_maximos = 100;
            }

        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            entradas_disponibles() {
                return this.zona.aforo - this.zona.confirmados - this.zona.no_confirmados + this.zona.count_bloqueados;
            },
            options() {
                let tope = this.asientos_maximos

                if(this.entradas_disponibles < tope) {
                    tope = this.entradas_disponibles;
                }

                var opciones = [];

                for(var i = 1; i <= tope; i++) {
                    opciones.push(i);
                }

                return opciones;
            }
        },
        watch: {
            n_entradas() {
                var datos = [];
                if(this.dia_abonado) {
                    datos.push({
                        'apellidos': this.abonado.apellidos,
                        'asiento': {
                            'zona_id': this.zona_seleccionada.id,
                            'asiento': 0,
                            'fila': 0,
                            'zona_nombre': this.zona_seleccionada.name
                        },
                        'dni': '',
                        'es_nuevo': true,
                        'nombre': this.abonado.nombre,
                        'precio': null,
                        'precios': this.zona_seleccionada.precios,
                        'telefono': '',
                        'url_imprimir': '',
                    });
                } else {
                    for (var i = 0; i < this.n_entradas; i++) {
                        datos.push({
                            'apellidos': '',
                            'asiento': {
                                'zona_id': this.zona_seleccionada.id,
                                'asiento': 0,
                                'fila': 0,
                                'zona_nombre': this.zona_seleccionada.name
                            },
                            'dni': '',
                            'es_nuevo': true,
                            'nombre': '',
                            'precio': '',
                            'precios': this.zona_seleccionada.precios,
                            'telefono': '',
                            'url_imprimir': ''
                        });
                    }
                }
                this.datos_de_compradores = datos;
            }
        },
        methods: {
            actualizar(siguiente, n_entradas = null) {
                this.loading = true;
                this.$emit('actualizarEntradas');
                this.$nextTick(function() {
                    this.siguiente = siguiente;
                    this.loading = false;
                });
            },
            bloquearAsientos() {
                this.loading = true;

                var seats = [];
                var params = null;

                this.datos_de_compradores = this.datos_de_compradores.filter(datos => Object.keys(datos).length !== 0);

                if (this.evento.tiene_recinto) {
                    for(var i in this.datos_de_compradores) {
                        seats.push(this.datos_de_compradores[i].asiento);

                        seats[i].row = this.datos_de_compradores[i].asiento.fila;
                        seats[i].seat = this.datos_de_compradores[i].asiento.asiento;
                    }

                    if (this.continuarConAsiento) {
                        params = {
                            filters: {
                                sesion_id: this.$route.params.sesion_id,
                                tid: this.configuracion.hash_teatro
                            },
                            zona_id: this.zona.id,
                            asientos: seats,
                            datos_abonado: this.datos_compradores,
                            tid: this.configuracion.hash_teatro
                        }
                    } else {
                        params = {
                            filters: {
                                sesion_id: this.$route.params.sesion_id,
                                tid: this.configuracion.hash_teatro
                            },
                            zona_id: this.zona.id,
                            asientos: seats,
                            tid: this.configuracion.hash_teatro
                        }
                    }
                } else {
                    params = {
                        filters: {
                            sesion_id: this.$route.params.sesion_id,
                            tid: this.configuracion.hash_teatro
                        },
                        entradas: this.entradas,
                        tid: this.configuracion.hash_teatro
                    }
                }

                params['taquilla'] = 1;

                this.$store.dispatch(this.config.getVuexAlias('front.bloquear.asientos'), params).then(res => {
                    if(res.data.error) {
                        this.$toast.error(res.data.message);
                    } else {
                        this.carrito_id = res.data.session_id;
                        this.loading = false;
                        this.$nextTick(function() {
                            this.goTo(3);
                        });
                    }
                }).catch(error => {
                    console.log(error);
                    this.$toast.error("Alguno de los asientos no son válidos o se ha producido un error");
                    this.loading = false;
                });
            },
            goTo(paso) {
                this.$emit('goTo', paso, this.datos_de_compradores, this.carrito_id);
            },
            actualizarDatos(datos) {
                this.datos_de_compradores = [];
                this.$nextTick(function() {
                    if (typeof (datos) !== 'number') {
                        this.datos_de_compradores = datos;

                        if(this.dia_abonado) {
                            for (let index = 0; index < this.datos_de_compradores.length; index++) {
                                if(index == 0) {
                                    this.datos_de_compradores[index].nombre = this.abonado.nombre;
                                    this.datos_de_compradores[index].apellidos = this.abonado.apellidos;
                                    this.datos_de_compradores[index].id = this.abonado.id;
                                    this.datos_de_compradores[index].precios = this.zona_seleccionada.precios_abonados;
                                } else {
                                    this.datos_de_compradores[index].precios = this.zona_seleccionada.precios_acompanantes;
                                }
                            }
                        } else if (this.mode === 3) {
                            for (let index = 0; index < this.datos_de_compradores.length; index++) {
                                this.datos_de_compradores[index].precios = this.zona_seleccionada.precios_amigo_abonado;
                            }
                        }
                    } else {
                        if(this.dia_abonado) {
                            for (let index = 0; index < datos; index++) {
                                this.datos_de_compradores.push({});
                                this.datos_de_compradores[index].asiento = {
                                    zona_id: this.zona_seleccionada.id,
                                    asiento: 0,
                                    fila: 0,
                                    zona_nombre: this.zona_seleccionada.name
                                };

                                if(index === 0) {
                                    this.datos_de_compradores[index].nombre = this.abonado.nombre;
                                    this.datos_de_compradores[index].apellidos = this.abonado.apellidos;
                                    this.datos_de_compradores[index].id = this.abonado.id;
                                    this.datos_de_compradores[index].precios = this.zona_seleccionada.precios_abonados;
                                } else {
                                    this.datos_de_compradores[index].precios = this.zona_seleccionada.precios_acompanantes;
                                }

                            }
                        } else if (this.mode === 3) {
                            for (let index = 0; index < datos; index++) {
                                this.datos_de_compradores[index].precios = this.zona_seleccionada.precios_amigo_abonado;
                                this.datos_de_compradores[index].asiento = {
                                    zona_id: this.zona_seleccionada.id,
                                    asiento: 0,
                                    fila: 0,
                                    zona_nombre: this.zona_seleccionada.name
                                };
                            }
                        }
                    }
                });
            },
            cambiarZona(new_zona) {
                this.$emit('resetDatos', new_zona);
                this.$nextTick(function() {
                    this.zona_seleccionada = new_zona;
                });
            },
            updateAsientos() {
                this.$emit('resetDatos', this.zona_seleccionada);
            }
        },
        components: {
            AsientosComponent, SelectorZonaComponent, TusAsientosComponent, EntradasSinRecintoComponent, DatosEntradasSinZonaComponent
        }
    }
</script>
